import { QueryClientProvider } from "@tanstack/react-query";
import { useMemo, type ReactNode } from "react";
import { BrowserRouter } from "react-router-dom";

import { createQueryClient } from "@shared/api";

import { AuthGate } from "./AuthGate";

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  const queryClient = useMemo(() => createQueryClient(), []);
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthGate>{children}</AuthGate>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
